/**
 * Custom validator for valid house number
 * @param {String} value | input value
 * @param {Object} options
 * @returns {String|null} returns null which validates as true in validate.js or an error string
 */
const hasHouseNumber = function (value, options) {
  const hasNumber = /\d+/.test(value)
  if (!hasNumber) {
    return options
  }
  return null
}
export default hasHouseNumber
